export default [
    {
        path: '/herbsintroduction',
        name: '本草性味及药症',
        component: ()=>import("../page/knowledgeBase/herbsIntroduction")
    },
    {
        path: '/classicalprescription',
        name: '医圣经方集',
        component: () => import("../page/knowledgeBase/classicalPrescription"),
    },
    {
        path: '/classicalprescriptionchapters',
        name: '医圣经方集标题',
        component: () => import("../page/knowledgeBase/classicalPrescription/chapters"),
    },
    {
        path: '/classicalprescriptioncontent',
        name: '医圣经方集内容',
        component: () => import("../page/knowledgeBase/classicalPrescription/chapters/content"),
    },
]
